<div
  class="focus-link container rounded-md"
  (click)="handleClick(pointsAccount)">
  <div class="card-container">
    <img [src]="imgUrl" alt="" />

    <h2 class="card-name m-0">{{ enrollment.groupName }}</h2>
    <p class="card-expiry">
      {{
        'wl.anz.card_select.card_ending'
          | translate: { cardLastFour: cardLastFour }
      }}
    </p>
  </div>
  <div class="card-details">
    <p class="card-details-balance">
      {{ pointsAccount?.pointsBalance | localizePointsNumber: '1.0-0' }}
      {{ loyaltyCurrency.name }}
    </p>
    <p class="card-details-expiry">
      {{
        'wl.anz.card_select.expiry'
          | translate
            : {
                lastDayOfYear: lastDayOfYear,
                expiringPoints:
                  expiringPointsNumber | localizePointsNumber: '1.0-0'
              }
      }}
    </p>

    <rd-shared-button
      class="button focus-link"
      [ariaLabel]="
        'wl.anz.card_select.select_card'
          | translate: { cardName: enrollment.groupName }
      "
      [buttonText]="'wl.anz.card_select.select' | translate"
      [buttonTheme]="'secondary'"></rd-shared-button>
  </div>
</div>
